import React from "react";
import { useTranslation } from "react-i18next";
import "./MarqueeSection.scss";

const MarqueeSection: React.FC = () => {
  const { t } = useTranslation();
  const items = t("marquee.items", { returnObjects: true }) as string[];
  const doubled = [...items, ...items];

  return (
    <div className="marquee-section" aria-hidden="true">
      <div className="marquee-track">
        {doubled.map((phrase, i) => (
          <span key={i}>{phrase}</span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeSection;
